
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Container from '@mui/material/Container';
import Grid2 from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    flexGrow: 1,
}));

const Ville = (props: { children: React.ReactNode; }) => {
    return <Item>{props.children}</Item>;
};

const ServiceItem = (props: { children: React.ReactNode; }): React.ReactNode => {
    return <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>{props.children}</Grid2>;
};

export const Applications = () => {
    return <Container>
        <Box sx={{ p: 4 }}>
            <Box>
                <Typography variant='h2' sx={{ p: 2, textAlign: 'center' }}>
                    Applications
                </Typography>
            </Box>
            <Box>
                <Grid2 container spacing={2}>
                    <ServiceItem>
                        <Card>
                            <CardMedia
                                sx={{ height: 140 }}
                                image="/images/fondations_residentielles.jpg"
                                title="Pieux vissés - Soutien d'une fondation résidentielle"
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Fondations Résidentielles
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    <strong>Stabilise</strong>, <strong>renforce</strong> et <strong>protège vos structures résidentielles</strong> contre l'affaissement. Adapté aux sols instables et <strong>minimise les travaux de creusage</strong>.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                    <ServiceItem>
                        <Card>
                            <CardMedia
                                sx={{ height: 140 }}
                                image="/images/reparation_fondation.jpg"
                                title="Pieux vissés - Réparation d'une fondation résidentielle"
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Réparation de fondation
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Des pieux visés sont utilisés pour stabiliser et renforcer une fondation endommagée et / ou affaissée. Solution <strong>rapide à installer</strong>.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                    <ServiceItem>
                        <Card>
                            <CardMedia
                                sx={{ height: 140 }}
                                image="/images/fondations_touristiques.jpg"
                                title="Pieux vissés - pour clôture, panneau d'affichage, enseigne, parasols, etc."
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Fondations touristiques
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Ancrage et stabilisation d'enseignes, panneaux commerciaux, ponts, belvédères, drapeaux, modules de jeux, parcs municipaux, etc.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                    <ServiceItem>
                        <Card>
                            <CardMedia
                                sx={{ height: 140 }}
                                image="/images/fondations_de_protection.jpeg"
                                title="Pieux vissés - pour vos besoin de protection."
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Fondations de protection
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Offez une base solide à vos clôture, bollards, rampes, murs de soutiens, supports pour appareillage industriels, etc.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                    <ServiceItem>
                        <Card>
                            <CardMedia
                                sx={{ height: 140 }}
                                image="/images/fondations_maritimes.jpg"
                                title="Pieux vissés - pour fondations maritimes."
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Fondations maritimes
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Solutions durables pour la stabilisation de quais, hangars à bateaux, ascenseurs à bateaux et chantiers littoraux.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                    <ServiceItem>
                        <Card>
                            <CardMedia
                                sx={{ height: 140 }}
                                image="/images/pieux_ancres_dans_roc.jpg"
                                title="Pieux vissés - Ancrage de peixu dans le roc."
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Ancrage dans le roc
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Installation adaptée pour tout types de sols, même en présence de roc.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                    <ServiceItem>
                        <Card>
                            <CardMedia
                                sx={{ height: 140 }}
                                image="/images/soudure_en_chantier.jpg"
                                title="Pieux Protech - Soudure en chantier."
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Service de soudure en chantier
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Notre service de soudure en chantier offre des solutions sur mesure pour vos structures résidentielles
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                </Grid2>
            </Box>
        </Box>
    </Container>;
};
